import * as React from "react";
import SettingsRadio from "./SettingsRadio";
import { StyledTable, StyledForm, StyledButtonGroup } from "styles/Settings";

interface IProps {
  options: [string, string][];
  defaultValue: Record<string, any>;
  onSubmit: (values: Record<string, number>) => Promise<void>;
}
const SettingForm = ({ options, onSubmit, defaultValue }: IProps) => {
  const [settings, setSettings] =
    React.useState<Record<string, any>>(defaultValue);
  const onClick = (key: string, value: number) => {
    const obj: Record<string, number> = {};
    obj[key] = value;
    setSettings({ ...settings, ...obj });
  };
  const onSubmitClick = (e: any) => {
    e.preventDefault();
    onSubmit(settings);
  };
  const onReset = (e: any) => {
    e.preventDefault();
    setSettings(defaultValue);
  };
  React.useEffect(() => {
    setSettings(defaultValue);
  }, [defaultValue]);

  return (
    <StyledForm>
      <div className="table-container">
        <StyledTable>
          <thead>
            <th>设定名称</th>
            <th>不显示</th>
            <th>全部显示</th>
            <th>仅会长, 管理员显示</th>
          </thead>
          <tbody>
            {options.map(([text, key], i) => {
              return (
                <SettingsRadio
                  key={i}
                  text={text}
                  valueKey={key}
                  onClick={onClick}
                  defaultActive={settings[key]}
                />
              );
            })}
          </tbody>
        </StyledTable>
      </div>
      <StyledButtonGroup>
        <button onClick={onSubmitClick}>送出</button>
        <button className="secondary" onClick={onReset}>
          重置
        </button>
      </StyledButtonGroup>
    </StyledForm>
  );
};

export default SettingForm;
